// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2qafE","gfeWrapper":"CalendarEvent_gfeWrapper__1UzK9"};